<template>
    <div class="container is-fullwidth mt-2 content">
        <table class="table">
            <thead>
                <tr>
                    <th width="5%">NIL</th>
                    <th width="20%">Sports Ref</th>
                    <th width="20%">Name</th>
                    <th width="5%">Rank</th>
                    <th>Comments</th>
                    <th width="10%">Amount</th>
                </tr>

            </thead>
            <tbody>
                <tr v-for="(row, index) in applications" :key="row.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ row.governing_body_short_name }}</td>
                    <td>{{ row.forename }} {{ row.surname }}</td>
                    <td>{{ row.ranking }}</td>
                    <td></td>
                    <td></td>
                </tr>
            </tbody>
        </table>

        
    </div>

</template>

<script>
import ApplicationService from '@/services/ApplicationService.js';

export default {
    data() {
        return {
            applications: []
        }
    },
    created() {
    
    this.getApplicationData();
    
   
  },
  methods : {
      async getApplicationData() {
      const accessToken = await this.$auth.getTokenSilently()
      // Use the eventService to call the getEventSingle() method
      ApplicationService.getApplications(accessToken, "endorsed", 0, "governing_body_name", "governing_bodies.short_name", "", 1)
      .then(
        (applications => {
          this.$set(this, "applications", applications);
        }).bind(this)
      )
      .catch((error) => {
       this.notfound = 1
        console.log(error)
      });

    }
    
  }
}
</script>

<style scoped>
    .columns {margin-bottom:0px;}
    table td, table th {padding:5px 0px}
    .table th {white-space: nowrap; text-align:left}

    .table tbody tr td {height:60px;padding:10px 0px}
    
    @media print {
        .content {font-size:0.8em !important}
    }

</style>